import { HTMLAttributes, ReactNode, forwardRef } from 'react';

export type BodyProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  variant?: 'dense';
  autoHeight?: boolean;
};

export const Body = forwardRef<HTMLDivElement, BodyProps>((props, ref) => {
  const { variant, autoHeight, ...rest } = props;

  return <div {...rest} ref={ref} />;
});

Body.displayName = 'DialogComposite.Body';

export default Body;
